import findBetStep from './findBetStep';
import roundBetByStep from './roundBetByStep';

export default function roundBet(bet: number): number {
    const betStep = findBetStep(bet);

    return roundBetByStep(bet, betStep);
}
